import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-477eacdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-dashboard container py-4 py-sm-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "line-chips"
}
const _hoisted_4 = { class: "price" }
const _hoisted_5 = { class: "amount" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "per" }, "per month", -1))
const _hoisted_7 = { class: "details" }
const _hoisted_8 = { class: "deal" }
const _hoisted_9 = { class: "number" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "number-label" }, "Your number", -1))
const _hoisted_11 = {
  key: 1,
  class: "line-chip placeholder"
}
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "hint" }
const _hoisted_16 = { class: "text-center mt-4" }

import { computed, onBeforeMount, ref } from "vue";
import { Sell, Sort, Iphone, User } from "@element-plus/icons-vue";
import { useAuthStore } from "@/stores/auth";
import { useUserStore } from "@/stores/user";
import { getCustomerOrders } from "@/api/customer";
import { CustomerOrdersDto } from "@/api-client";
import { formatDate, formatNumber } from "@/utilities/index";
import brand from "@/brand";
import PageHero from "@/components/misc/PageHero.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandDashboard',
  setup(__props) {

const authStore = useAuthStore();
const userStore = useUserStore();
const orders = ref<CustomerOrdersDto[]>([]);
const loading = ref(true);

// Recharge and Change Deal live on the products page, next to the line they act on.
const actions = [
  { label: "Recharge", hint: "Add data now", icon: Sell, route: "Products" },
  { label: "Change Deal", hint: "Upgrade or downgrade", icon: Sort, route: "Products" },
  { label: "My Products", hint: "Lines, bills, payments", icon: Iphone, route: "Products" },
  { label: "My Profile", hint: "Your details", icon: User, route: "Profile" },
];

// Every line the customer has on this brand's network, active or still being activated, each with its order.
const lines = computed(() => orders.value.flatMap((order) =>
  (order.orderProducts || [])
    .filter((p) => !p.isTopUp && p.products?.provider === brand.provider && ["New", "Activated"].includes(p.orderProductStatusesId))
    .map((product) => ({ order, product }))));

onBeforeMount(async () => {
  try {
    if (userStore.id) orders.value = (await getCustomerOrders(userStore.id, 1, 5)).data || [];
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHero, { subtitle: "Stay connected. Recharge, change your deal or check your bill, all in one place." }, {
      title: _withCtx(() => [
        _createTextVNode("Hello"),
        (_unref(userStore).name)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createTextVNode(", "),
              _createElementVNode("em", null, _toDisplayString(_unref(userStore).name), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (lines.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lines.value, (line) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: line.product.id,
                  to: { name: 'Products' },
                  class: "line-chip"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, "R" + _toDisplayString(Math.round(line.product.products.vascoPrice)), 1),
                      _hoisted_6
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(line.product.products.vascoDealDescription), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(line.product.msisdn ? _unref(formatNumber)(line.product.msisdn) : "Being activated"), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["due", { paused: line.order.billingPausedDate }])
                      }, _toDisplayString(line.order.billingPausedDate ? "Billing paused" : line.order.nextBillingDate ? `Next payment ${_unref(formatDate)(line.order.nextBillingDate)}` : ""), 3)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_12, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(actions, (action) => {
        return _createVNode(_component_router_link, {
          key: action.label,
          to: { name: action.route },
          class: "action"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(action.icon)))
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("span", _hoisted_14, _toDisplayString(action.label), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(action.hint), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: "btn btn-link logout",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).logout()))
      }, "Log out")
    ])
  ]))
}
}

})